module.exports = __webpack_public_path__ + "img/logo.49b65b7f.png";